document.addEventListener('DOMContentLoaded', function () {
  const newsletterForms = document.querySelectorAll('.bfwt-newsletter-lazy');

  const initForm = (form) => {
    const emailInput = form.querySelector('#bfwt-newsletter-email-input');
    if (!emailInput || form.classList.contains('is-initialized')) {
      return;
    }

    const loadScripts = () => {
      form.classList.add('is-initialized');

      const submitButton = form.querySelector('.bfwt-newsletter-form__submit');
      const turnstileWrapper = form.querySelector('.bfwt-turnstile-wrapper');
      const newsletterScriptUrl = form.dataset.newsletterScript;
      const turnstileSiteKey = form.dataset.turnstileSitekey;

      // Load main newsletter script
      if (
        newsletterScriptUrl &&
        !document.getElementById('bfwt-newsletter-js')
      ) {
        const newsletterScript = document.createElement('script');
        newsletterScript.id = 'bfwt-newsletter-js';
        newsletterScript.src = newsletterScriptUrl;
        newsletterScript.defer = true;
        document.body.appendChild(newsletterScript);
      }

      // Handle Turnstile - Use global init system
      if (turnstileSiteKey && turnstileWrapper) {
        turnstileWrapper.style.display = 'block';

        // Create standard Turnstile container that will be picked up by BfwtTurnstileInit.js
        const turnstileDiv = document.createElement('div');
        turnstileDiv.className = 'bfwt-turnstile-container';
        turnstileDiv.dataset.sitekey = turnstileSiteKey;
        turnstileWrapper.appendChild(turnstileDiv);

        // Load Turnstile script if not already loaded
        if (
          !document.querySelector(
            'script[src*="challenges.cloudflare.com/turnstile"]'
          )
        ) {
          const turnstileInitScript = document.createElement('script');
          const pluginJsUrl =
            window.bfwtVars?.pluginJsUrl ||
            '/wp-content/plugins/budgetfitter-web-theme/Assets/js/';
          turnstileInitScript.src =
            pluginJsUrl + 'BfwtTurnstileInit.js';
          turnstileInitScript.defer = true;
          document.body.appendChild(turnstileInitScript);
        } else if (typeof window.initializeTurnstile === 'function') {
          // If Turnstile is already loaded, initialize it
          window.initializeTurnstile();
        }

        // Enable button when Turnstile is ready
        document.addEventListener(
          'bfwt-turnstile-ready',
          function () {
            if (submitButton) {
              submitButton.disabled = false;
            }
          },
          { once: true }
        );
      } else {
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    };

    // Use IntersectionObserver for better performance
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              loadScripts();
              observer.disconnect();
            }
          });
        },
        { rootMargin: '100px' }
      );

      observer.observe(form);
    } else {
      // Fallback to focus/click events
      emailInput.addEventListener('focus', loadScripts, { once: true });
      emailInput.addEventListener('click', loadScripts, { once: true });
    }
  };

  newsletterForms.forEach(initForm);
});
